/**
 * What a task phase is called on screen.
 *
 * Pure, and in its own module so both the phase list and the tasks table read
 * the same label from the same place -- a compose task's phases are the only
 * thing that carries the cleaning zone, so two implementations of this would
 * be two different answers to "which zone was that".
 */
import type { TaskPhase } from '../../api/v1';

export function phaseLabel(phase: TaskPhase): string {
  const place = typeof phase.params?.place === 'string' ? phase.params.place : undefined;
  return place ?? phase.description;
}
